<template>
  <div class="loading-container">
    <CircleLoader></CircleLoader>
  </div>
</template>

<script>
import CircleLoader from 'vue-loading-spinner/src/components/Circle';
export default {
    name: 'PreLoader',
    components: {CircleLoader}
}
</script>

<style scoped>
.loading-container{
  text-align: center;
}
</style>